import { RegionSetQualifier } from "@app/region-sets";

interface SpecialtyGroupExceptionDisplay extends SpecialtyGroupException {
  regionSetDescription: string;
  regionSetStateName: string;
  updatedByUserFullName: string;
}

interface SpecialtyGroupException extends RegionSetQualifier {
  specialtyGroupExceptionId: number;
  customProjectId: number;
  specialtyGroupCode: string;
  specialtyGroupExceptionStatus: SpecialtyGroupExceptionStatus;
  dateUpdated: Date;
  dateStatusUpdated: Date;
  updatedByUserId: number;
  previouslyApproved: boolean;
  comment: string;
  isUnprocessed?: boolean;
  exceptionNarrative: string;
  startDate?: Date;
  endDate?: Date;
  supplementaryDocuments?: SupplementaryDocument[];
  grade: SpecialtyGroupExceptionGrade;
}

interface SpecialtyGroupExceptionHistory extends SpecialtyGroupException {
    updatedByUserFullName: string;
    supplementaryDocuments?: SupplementaryDocumentHistory[];
}

interface CreateSpecialtyGroupException {
  regionSetId: number;
  specialtyGroupCode: string;
  specialtyGroupExceptionStatus: SpecialtyGroupExceptionStatus;
  startDate?: Date;
  endDate?: Date;
  dateUpdated: Date;
  dateStatusUpdated: Date;
  previouslyApproved: boolean;
  comment: string;
  exceptionNarrative: string;
  supplementaryDocuments?: SupplementaryDocument[]
  grade: SpecialtyGroupExceptionGrade;
}

interface UpdateSpecialtyGroupException {
  specialtyGroupExceptionId: number;
  specialtyGroupExceptionStatus: SpecialtyGroupExceptionStatus;
  previouslyApproved: boolean;
  comment: string;
  exceptionNarrative: string;
  startDate?: Date;
  endDate?: Date;
  supplementaryDocuments?: SupplementaryDocument[];
  grade: SpecialtyGroupExceptionGrade;
}

interface SupplementaryDocument {
  specialtyGroupExceptionId?: number;
  supplementaryDocumentMetadataId: number;
  documentName: string
}

interface ProjectFilterOptions {
  [key: string]: string;
}

interface SpecialtyFilterOptions {
  key: string;
  value: string;
}

interface ServiceAreaFilterOptions {
  countyRegionSetId: number;
  countyDisplayName: string;
  stateAbbreviation: string;
  stateName: string;
  countySSA: string;
}

interface KeyedServiceAreas {
  [stateAbbreviation: string]: ServiceAreaFilterOptions[];
}

interface BulkFilterData {
  bulkProjects: ProjectFilterOptions;
  bulkSpecialties: SpecialtyFilterOptions[];
  bulkServiceAreas: KeyedServiceAreas;
}

// This could be updated with an updatedByUserFullName field to align with the backend model, if necessary
type SupplementaryDocumentHistory = SupplementaryDocument;

interface UploadBulkExceptionsResponse {
  message: string;
  validRecords: UploadBulkExceptionsValidRecord[];
  invalidRecords: UploadBulkExceptionsInvalidRecords;
  totalRecords: number;
  totalOverwrittenExceptions: number
}

interface UploadBulkExceptionsValidRecord {
  specialtyGroupExceptionId: number;
  customProjectId: number;
  regionSetId: number;
  regionGranularity: string;
  specialtyGroupCode: string;
  specialtyGroupExceptionStatus: string;
  dateUpdated: string;
  updatedByUserId: number;
  previouslyApproved: boolean;
  comment: string;
  exceptionNarrative: string;
  startDate: string;
  endDate: string;
}

interface UploadBulkExceptionsInvalidRecords {
  [key: string]: number;
}

enum SpecialtyGroupExceptionStatus {
  None = "none",
  Pending = "pending",
  Submitted = "submitted",
  Approved = "approved",
  Denied = "denied",
  Appealed = "appealed",
  Archived = "archived",
  Expired = "expired",
}

enum SpecialtyGroupExceptionGrade {
  None = "none",
  A = "a",
  B = "b",
  C = "c",
}

enum SortExceptionColumn {
  DateUpdated = "dateUpdated",
  CustomProjectName = "customProjectName",
  ServiceArea = "serviceArea",
  RegionSetStatus = "regionSetStatus",
  Specialty = "specialty",
  GapResolutionStatus = "gapResolutionStatus",
  Grade = "grade",
  StartDate = "startDate",
  EndDate = "endDate",
  SpecialtyGroupExceptionStatus = "specialtyGroupExceptionStatus",
  PreviouslyApproved ="previouslyApproved",
  HasComments = "hasComments",
  HasNarrative = "hasNarrative",
  ProcessingStatus = "processingStatus",
  UpdatedByUserFullName = "updatedByUserFullName",
  MetOverall = "metOverall",
  LineOfBusiness = "lineOfBusiness",
  HasUnprocessedExcludedProviders = "hasUnprocessedExcludedProviders",
}

export {
  SpecialtyGroupException as default,
  CreateSpecialtyGroupException,
  SpecialtyGroupExceptionDisplay,
  SpecialtyGroupExceptionGrade,
  SpecialtyGroupExceptionHistory,
  SpecialtyGroupExceptionStatus,
  SortExceptionColumn,
  UpdateSpecialtyGroupException,
  SupplementaryDocument,
  ServiceAreaFilterOptions,
  BulkFilterData,
  SupplementaryDocumentHistory,
  UploadBulkExceptionsResponse,
  UploadBulkExceptionsValidRecord,
  UploadBulkExceptionsInvalidRecords
};
